<template>
    <div id="description" class="synopsis">
        <!-- 标题 -->
        <div class="synopsis-row">
            <div class="synopsis-header">
                <span v-if="isMobile" style="color:F8F2D8;">{{$t("summary")}}</span>
            </div>
        </div>
        <div class="synopsis-row">
            <div class="swiper-box">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <img src="@assets/imgs/store1.jpg" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@assets/imgs/store2.jpg" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@assets/imgs/store3.jpg" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@assets/imgs/store4.jpg" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@assets/imgs/store5.jpg" />
                        </div>
                    </div>
                    <!-- 如果需要分页器 -->
                    <!-- 如果需要导航按钮 -->
                    <!-- 如果需要滚动条 -->
                    <!-- <div class="swiper-scrollbar"></div> -->
                </div>
                <!-- 如果需要分页器 -->
                <div v-if="!isMobile" class="swiper-pagination page"></div>
                <!-- 如果需要导航按钮 -->
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";

export default {
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        cdnPrefix: {
            type: String,
            default: ""
        }
    },
    data() {
        return {};
    },
    components: {},
    mounted() {
        this._initSwiper();
    },
    methods: {
        // Swiper
        _initSwiper() {
            let mySwiper = new Swiper("#description .swiper-container", {
                initalSlide: 2, //设定初始化时slide的索引，
                // direction: "vertical",//slide的滑动方向
                speed: 500, //滑动速度，开始滑动到结束滑动的时间
                autoplay: 500, //可选选项，自动滑动,值为自动滑动的间隔
                autoplayDisableOnInteraction: false, //操作后是否停止自动滑动
                autoplayStopOnLast: false, //设置为true，切换到最后一个slide时停止自动切换
                grabCursor: true, //拖动时指针会变成抓手形状
                loop: true,
                // 分页器 - 即小圆点
                pagination: {
                    el: "#description .swiper-pagination",
                    clickable: true, //可点击切换
                    type: "bullets" //bullets 圆点（默认） fraction 分式 progressbar 进度条 custom 自定义
                },
                // 左右的切换按钮
                navigation: {
                    nextEl: "#description .swiper-button-next",
                    prevEl: "#description .swiper-button-prev"
                },
                // 鼠标滚轮控制切换
                mousewheel: true,
                // 切换效果 fade cube coverflow flip
                effect: "cube"
            });
        }
    }
};
</script>

<style lang="scss">
.synopsis {
    height: 100%;
    min-height: 800px;
    padding: 70px 0 100px;
    .synopsis-row {
        width: 100%;
        display: flex;
        justify-content: center;
        .synopsis-header {
            background: url("~@assets/imgs/title-youxitese.png") center
                center no-repeat;
            background-size: 100% auto;

            width: 350px;
            height: 100px;
            margin-top: 50px;
            img {
                width: 100%;
            }
        }
        .swiper-box {
            position: relative;
            width: 1140px;
            margin: 0 auto;
            padding: 0 70px;
            .swiper-container {
                width: 100%;
                .swiper-wrapper {
                    .swiper-slide {
                        width: 1000px;
                        img {
                            width: 1000px;
                        }
                    }
                }
            }
            // 分页按钮
            .swiper-pagination {
                width: 1000px;
                height: 50px;
                line-height: 50px;
                .swiper-pagination-bullet {
                    width: 12px;
                    height: 12px;
                    margin: 0 5px;
                    background: #fff;
                    opacity: 0.8;
                    transition: all 0.1s linear;
                    outline: none;
                }
                .swiper-pagination-bullet-active {
                    background: #f00;
                }
            }
            // 翻页按钮
            .swiper-button-prev,
            .swiper-button-next {
                width: 40px;
                height: 50px;
                outline: none;
            }
            .swiper-button-prev {
                background: url("~@assets/imgs/btn_prev.png") center center
                    no-repeat;
                background-size: 100% 100%;
                left: 5px;
            }
            .swiper-button-next {
                background: url("~@assets/imgs/btn_next.png") center center
                    no-repeat;
                background-size: 100% 100%;
                right: 5px;
            }
        }
    }
}
@media screen and (max-width: 1440px) {
    .synopsis {
        .synopsis-row {
            .synopsis-header {
                margin-top: 50px;
            }
            .swiper-box {
                position: relative;
                width: 800px;
                margin: 0 auto;
                padding: 0 70px;
                .swiper-container {
                    .swiper-wrapper {
                        width: 100%;
                        .swiper-slide {
                            width: 100%;
                            img {
                                width: 660px;
                            }
                        }
                    }
                }
                // 分页按钮
                .swiper-pagination {
                    width: 660px;
                    height: 30px;
                    line-height: 30px;
                }
                // 翻页按钮
                .swiper-button-prev,
                .swiper-button-next {
                    width: 40px;
                    height: 41px;
                    outline: none;
                }
                .swiper-button-prev {
                    background: url("~@assets/imgs/btn_prev.png") center
                        center no-repeat;
                    background-size: 70% 100%;
                    left: 5px;
                }
                .swiper-button-next {
                    background: url("~@assets/imgs/btn_next.png") center
                        center no-repeat;
                    background-size: 70% 100%;
                    right: 5px;
                }
            }
        }
    }
}
// 移动端
@media screen and (max-width: 768px) {
    .synopsis {
        height: auto;
        min-height: 300px;
        padding: 0;
        .synopsis-row {
            .synopsis-header {
                width: 250px;
                height: 60px;
                margin: 20px auto;
            }
            .swiper-box {
                width: 600px;
                .swiper-container {
                    .swiper-wrapper {
                        .swiper-slide {
                            img {
                                width: 500px;
                            }
                        }
                    }
                }
                // 分页按钮
                .swiper-pagination {
                    width: 500px;
                }
            }
        }
    }
}
@media screen and (max-width: 500px) {
    #description {
        padding: 0 0 50px;
        .synopsis-row {
            .synopsis-header {
                width: 100%;
                margin: 20px auto;
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                font-weight: bold;
                color: #f8f2d8;
                background: url("~@assets/imgs/bgphone-title.png") center
                    center no-repeat;
                background-size: 330px 35px;
                text-align: center;
            }
            .swiper-box {
                width: 90%;
                padding: 10px 0;
                .swiper-container {
                    width: 80%;
                    .swiper-wrapper {
                        width: 100%;
                        .swiper-slide {
                            img {
                                width: 100%;
                            }
                        }
                    }
                }
                // 分页按钮
                .swiper-pagination {
                    width: 100%;
                }
                // 翻页按钮
                .swiper-button-prev,
                .swiper-button-next {
                    width: 30px;
                    height: 30px;
                }
            }
        }
    }
}
@media screen and (max-width: 360px) {
    #description {
        .synopsis-row {
            .swiper-box {
                .swiper-container {
                    width: 70%;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Description.vue